export default __webpack_public_path__ + "static/media/pomodoro_screen.f5bdfe3b.png";